import React from 'react';

import styles from './cardFeedHighlightStyles';

const CardFeedHighlight = ({ children }) => {
  // Component logic goes here...

  return <div className={styles.cardFeedHighlight}>{children}</div>;
};

export default CardFeedHighlight;
